import { TableCell } from "@mui/material";
import { IAdditional } from "../../TableTemplate/tableTemplate";
import Button from "../../../Components/Button";
import Modal from "../../../Components/Modal/Modal";
import { useState } from "react";
import SahraOrderTable from "../SahraOrder/SahraOrderTable";
import { getManualSahraOrderTable } from "../../../Requests/manualRequests";
import { IManualSubOrdersTableReport } from "../../../Interfaces/manualInterfaces";

const SubOrdersTableAdditionalHeader = () => {
  return (
    <>
      <TableCell></TableCell>
    </>
  );
};

const SubOrdersTableAdditionalCol: React.FC<{
  row: IManualSubOrdersTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [isChancesModalOpen, setIsChancesModalOpen] = useState(false);

  return (
    <>
      <TableCell>
        {isDetailsModalOpen ? (
          <Modal
            UI={
              <SahraOrderTable
                getData={getManualSahraOrderTable}
                searchParam={{ manualOrderId: row.id }}
              />
            }
            onClose={() => setIsDetailsModalOpen(false)}
          />
        ) : null}
        <Button
          onClick={() => setIsDetailsModalOpen(true)}
          text="جزییات"
          variant="contained"
          className="table-btn"
        />
      </TableCell>
      {/* <TableCell>
        {isChancesModalOpen ? (
          <Modal
            UI={<SubOrderChancesTable shekarOrderId={row.shekarOrderId} />}
            onClose={() => setIsChancesModalOpen(false)}
          />
        ) : null}
        <Button
          onClick={() => setIsChancesModalOpen(true)}
          text="شانس ها"
          variant="contained"
          className="table-btn"
        />
      </TableCell> */}
    </>
  );
};

export const SubOrdersTableAdditional: IAdditional<IManualSubOrdersTableReport> =
  {
    getHeader: SubOrdersTableAdditionalHeader,
    getRow: SubOrdersTableAdditionalCol,
  };
